import { call, select } from 'redux-saga/effects';

import * as Actions from '../../../actions';
import { putAndWait } from '../../../sagas/TaskManager';
import * as Utils from '../../../utils';

export function* isAuthenticatedListener() {
  return yield select(Utils.Listener.isAuthenticatedListener);
}

export function* unauthenticatedUpgrade(tierSlug, subTierSlug) {
  const processUpgradeAuthentication = Actions.Payments.processUpgradeAuthentication({
    tierSlug,
    subTierSlug,
  });
  yield call(putAndWait, processUpgradeAuthentication);
}

export function* authenticatedUpgrade(tierSlug, subTierSlug) {
  const processUpgradeFlow = Actions.Payments.processUpgrade({
    tierSlug,
    subTierSlug,
  });

  yield call(putAndWait, processUpgradeFlow);
}
